function nodeScriptReplace(node) {
  if (node.tagName === 'SCRIPT') {
    node.parentNode.replaceChild(nodeScriptClone(node), node);
  } else {
    let i = -1, children = node.childNodes;
    while (++i < children.length) {
      nodeScriptReplace(children[i]);
    }
  }

  return node;
}

function nodeScriptClone(node) {
  let script = document.createElement('script');
  script.text = node.innerHTML;

  let i = -1, attrs = node.attributes, attr;
  while (++i < attrs.length) {
    script.setAttribute((attr = attrs[i]).name, attr.value);
  }
  return script;
}

/**
 * Asynchrone Funktion um Seite ohne neuladen upzudaten
 *
 * @param form
 * @param method
 * @param data
 * @param sendForm
 * @returns {Promise<void>}
 */
const fetchCall = (form, data = {}, method = 'POST', sendForm = true) => {
  const container = document.getElementById(form.dataset.ajaxcontainer);
  const url = form.dataset.ajaxurl;
  let _formData = {};
  if (data.length === 0) {
    _formData = new FormData(form);
  } else {
    _formData = sendForm ? new FormData(form) : new FormData();
    for (let k in data) {
      _formData.append(k, data[k]);
    }
  }
  fetch(url, {
    method: method,
    body: _formData,
  }).then((res) =>
      res.text(),
  ).then((data) => {
    container.innerHTML = data.toString();
    nodeScriptReplace(container);
    fetchResults();
  }).catch((err) => {
    console.log(err);
  });
};

window.fetchResults = (updateCounter = false) => {
  fetch(MP_PATH + 'templates/inc/inc.reifenfinder_results.php',
  ).then((res) => res.text(),
  ).then((data) => document.getElementById('productlist-wrap').innerHTML = data.toString(),
  ).then((res) => {
        // Ergebnis-Counter aktualisieren
        if (updateCounter) {
          const productItems = $('#productlist-wrap .product-item');
          let productItemCount = 0;
          if (productItems) {
            productItemCount = productItems.length;
          }
          $('#show-results i').text('(' + productItemCount + ')');
        }
      },
  ).catch((err) => console.log(err));
};

window.nextStep = (id = 'next', event = 'click') => {
  if (document.getElementById(id)) {
    document.getElementById(id).addEventListener(event, (e) => {
      e.preventDefault();
      const newStep = document.getElementById(id).dataset.step;
      document.querySelector('[name=goTo]').value = 'step';
      fetchCall(document.getElementById('tire-finder'), {
        'step': newStep,
      });
    });
  }
};

window.prevStep = (id = 'back', event = 'click') => {
  if (document.getElementById(id)) {
    document.getElementById(id).addEventListener(event, (e) => {
      e.preventDefault();
      const newStep = document.getElementById(id).dataset.step;
      document.querySelector('[name=goTo]').value = 'step';
      fetchCall(document.getElementById('tire-finder'), {
        'step': newStep,
      });
    });
  }
};

const goToStep = () => {
  var stepsMobile = document.querySelector('.steps.mobile');
  if (stepsMobile) {
    stepsMobile.addEventListener('change', () => {
      fetchCall(document.getElementById('tire-finder'), {
        'step': document.querySelector('.steps.mobile').options[document.querySelector('.steps.mobile').selectedIndex].value.substr(0, 1),
        'goTo': 'step',
      });
    });
  }
  var stepNumbers = document.querySelectorAll('.step-number');
  if (stepNumbers) {
    stepNumbers.forEach(stepButton => {
      let stepParent = stepButton.parentNode;
      stepParent.addEventListener('click', () => {
        fetchCall(document.getElementById('tire-finder'), {
          'step': stepButton.innerText,
          'goTo': 'step',
        });
      });
    });
  }
};

window.setMenuPoint = () => {
  let menuPoints = document.getElementsByClassName('step-' + document.getElementsByTagName('fieldset')[0].id.substring(5));
  if (document.getElementsByTagName('fieldset')) {
    document.querySelectorAll('.steps.desktop .step-item').forEach((menuPoint) => {
      menuPoint.classList.remove('active');
    });
    document.querySelectorAll('.steps.mobile .step-item').forEach((menuPoint) => {
      menuPoint.removeAttribute('selected');
    });

    //menuPoints[0].classList.add('active')
    if (menuPoints[0].tagName !== 'div') {
      menuPoints[1].classList.add('active');
    }

    if (menuPoints[1].tagName !== 'option') {
      menuPoints[0].setAttribute('selected', true);
    }

  }
};

window.steSliderVal = (sliderId, imgId) => {
  if (document.getElementById(sliderId) && document.getElementById(sliderId).hasAttribute('data-sizes') === true) {

    const dataset = parseInt(document.getElementById(sliderId).dataset.sizes);
    let inputVal = parseInt(document.getElementById(sliderId).value);
    const inputValSize = parseInt(document.querySelector('#laufradgroesse > option:nth-child(' + (inputVal + 1) + ')').value);

    // get wheel sizes
    let bigWheelElement = document.querySelector('#wheel-size > img');
    if (!bigWheelElement) {
      bigWheelElement = document.querySelector('#wheel-size > svg');
    }
    const getBigWheelSize = bigWheelElement.offsetHeight;
    let getSmallWheel = document.querySelector('#live-wheel-size > img');
    if (!getSmallWheel) {
      getSmallWheel = document.querySelector('#live-wheel-size > svg');
    }
    // reset transform scale
    getSmallWheel.style.removeProperty('transform');
    const getSmallWheelSize = getSmallWheel.offsetHeight;

    // calc big wheel size
    const pxSizeFromBigWheel = getBigWheelSize / dataset * inputValSize;

    // calc size difference to calced big wheel size
    const pxDiffBigCalcToSmall = pxSizeFromBigWheel - getSmallWheelSize;

    // calc percentage to add to get to target size
    const addPercentage = parseFloat(100 / getSmallWheelSize * pxDiffBigCalcToSmall);

    let targetImg = document.getElementById(imgId).querySelector('img');
    if (!targetImg) {
      targetImg = document.getElementById(imgId).querySelector('svg');
    }

    targetImg.style.transform = 'scale(' + ((addPercentage / 100) + 1) + ')';
  }
};

window.setSelectedWheel = (id, trigger, wheelClassQSE, toggleClass = 'selected') => {
  if (document.getElementById(id)) {
    document.getElementById(id).addEventListener(trigger, () => {
      document.querySelector(wheelClassQSE).classList.toggle(toggleClass);
    });
    if (document.getElementById(id).checked === true) {
      document.querySelector(wheelClassQSE).classList.add(toggleClass);
    }
  }
};

window.resetFilter = () => {
  document.addEventListener('click', ev => {
    if (ev.target.id === 'reset' || ev.target.id === 'reset-img') {
      fetchCall(document.getElementById('tire-finder'), {reset: true, goTo: 'step', step: 1}, 'POST', true);
      window.scrollTo({top: 0, behavior: 'smooth'});
    }
  });
};

document.addEventListener('DOMContentLoaded', () => {
  nextStep();
  prevStep();
  goToStep();
  resetFilter();
});
